import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { convertImageUrl_L_to_M } from '~/backend/helper';

import { api_getByParentCategoryId, api_getCategoryByCode } from '~/backend/api_calls';

const Brands = () => {
	const { t } = useTranslation();

	const [manufacturers, setManufacturers] = useState([]);

	useEffect(() => {
		api_getCategoryByCode('BRANDS')
			.then(json => {
				api_getByParentCategoryId(json.id)
					.then(categories => {
						setManufacturers(categories.items);
					})
					.catch(error => {
						console.log(error);
					});
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	return (
		<div className="brandshome">
			<div className="content-wrapper">
				<div className="brands-container">
					{manufacturers?.map((item, index) =>
						item.img1 || item.img2 ? (
							<div key={index} className="brand-item">
								<Link to={item.eurl}>
									<img src={convertImageUrl_L_to_M(item.img1 ?? item.img2)} alt={item.nm} loading="lazy" width="167px" height="128px" />
								</Link>
							</div>
						) : null
					)}
				</div>
			</div>
		</div>
	);
};

export default Brands;
